import React from "react";

const NewTooltips = () => {
  return (
    <div className="cursor-pointer">
      <svg
        width={17}
        height={16}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.333 8A6.667 6.667 0 102 8a6.667 6.667 0 0013.333 0z"
          stroke="#98A2B3"
          strokeWidth={1.2}
        />
        <path
          d="M8.823 11.333V8c0-.315 0-.472-.098-.57-.097-.097-.254-.097-.569-.097M8.656 5.333h.006"
          stroke="#98A2B3"
          strokeWidth={1.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default NewTooltips;
